'use client'
import React from 'react'

import type { Footer, Header } from '@/payload-types'
import { useLocale } from '@/providers/Locale'
import { useHeaderVariant } from '@/providers/HeaderVariant'
import { cn } from '@/utilities/ui'

import { StandardHeader } from './variants/StandardHeader'
import { MinimalHeader } from './variants/MinimalHeader'
import { ThinHeader } from './variants/ThinHeader'
import { AYAdSlot } from '@/components/frontend/AYAdSlot'

interface HeaderClientProps {
    data: Header
    footer: Footer
}

export const HeaderClient: React.FC<HeaderClientProps> = ({ data, footer }) => {
    const { locale } = useLocale()
    const { headerVariant } = useHeaderVariant()
    const { variant, theme } = headerVariant

    return (
        <>
            <div
                className={cn('md:hidden', {
                    ' border-b-4 border-[#105B8E]': variant === 'standard',
                })}
            >
                <AYAdSlot adId='qz.com_320x50' width={320} height={50} />
            </div>
            <header
                className={cn('container relative z-20 dark:invert dark:bg-white dark:text-black', {
                    'max-w-[1300px]': variant === 'standard' || variant === 'nonav',
                    'max-w-full': variant === 'minimal' || variant === 'thin',
                })}
                data-theme={theme}
            >
                {['nonav', 'standard'].includes(variant) && <StandardHeader locale={locale} header={data} footer={footer} showNav={variant !== 'nonav'} />}
                {variant === 'minimal' && <MinimalHeader />}
                {variant === 'thin' && <ThinHeader header={data} footer={footer} title={headerVariant.title} />}
            </header>
        </>
    )
}
